export default __webpack_public_path__ + "static/media/Loading.b544d249.gif";